function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { useSubscriptions } from '@adsk/alloy-provider';
import { TRIAL, STATUSES } from '../components/SubscriptionItem/helpers/consts';
const useUserSubscriptions = () => {
  const {
    data: userSubscriptionsData,
    error,
    loading,
    retry
  } = useSubscriptions();
  const sortedSubscriptions = useMemo(() => {
    const subscriptions = userSubscriptionsData || [];
    const activeSubscriptions = subscriptions.filter(subscription => subscription.status === STATUSES.ACTIVE);

    // For each TRL element we check if it has duplicate

    activeSubscriptions === null || activeSubscriptions === void 0 ? void 0 : activeSubscriptions.forEach((subscription, index) => {
      if ((subscription === null || subscription === void 0 ? void 0 : subscription.type) === TRIAL) {
        //If we find a trial we check if it has other paid subscription
        activeSubscriptions.forEach((subscription2, index2) => {
          if ((subscription === null || subscription === void 0 ? void 0 : subscription.offeringName) === subscription2.offeringName && subscription2.type !== TRIAL && index !== index2) {
            activeSubscriptions.push(_objectSpread(_objectSpread({}, subscription2), {}, {
              alternativeSubscription: {
                daysRemaining: subscription.daysRemaining,
                offeringName: subscription.offeringName,
                type: subscription.type
              }
            }));
            activeSubscriptions[index] = _objectSpread(_objectSpread({}, activeSubscriptions[index]), {}, {
              type: 'removable'
            });
            activeSubscriptions[index2] = _objectSpread(_objectSpread({}, activeSubscriptions[index2]), {}, {
              type: 'removable'
            });
            return;
          }
          return;
        });
      }
      return;
    });
    return activeSubscriptions.filter(value => value.type !== 'removable').sort((a, b) => {
      if (!b.daysRemaining) return 1;
      if (!a.daysRemaining) return -1;
      return b.daysRemaining - a.daysRemaining;
    });
  }, [userSubscriptionsData]);
  return {
    subscriptions: sortedSubscriptions,
    error: !!error,
    isLoading: loading,
    refetch: retry
  };
};
export default useUserSubscriptions;
//# sourceMappingURL=useUserSubscriptions.js.map